module.exports = __webpack_public_path__ + "static/media/dish-icon.56d645af.svg";